(ns common.schema.entities.risk-holding.permissions
  (:require
   [common.schema.entities.permission-checks :as permission-checks]))

(defn read-permissions?
  [_ctx]
  true)

(defn disable-permissions?
  [ctx]
  (permission-checks/risk-delete-check-fn ctx))
